import React from 'react';
import axios from 'axios';
import { getSession } from 'Vulture/Session';
import { broncoURL, commitHash } from 'Vulture/ENV';
import CustomIcon from '../Common/CustomIcon/CustomIcon';
import style from './ChonkyFileBrowser.module.css';

class EditFileModal extends React.Component {
    constructor(props) {
        super(props);
        const { file } = props;

        this.state = {
            fileName: file?.file_name || file?.name || '',
            description: file?.description || '',
            keywords: file?.keywords || '',
            tags: file?.tags || ''
        };
        
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleEditFile = this.handleEditFile.bind(this);
    }

    handleInputChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    async handleEditFile() {
        const { fileName, description, keywords, tags } = this.state;
        const { file, refreshFileBrowserData, app } = this.props;

        app.setState({ loading: true }); 
        try {
            const session = getSession();
            const backendFileId = file.id.replace('file_', '');

            const response = await axios.put(`${broncoURL}/api/file/${backendFileId}`, {
                file_name: fileName,
                description,
                keywords,
                tags,
            }, {
                headers: {
                    'X-Auth-Session': session.session,
                    'X-Spark-API-version': commitHash,
                }
            });
            
            if (response.status === 200) {
                await refreshFileBrowserData();
                app.closeModal();
            }
        } catch (err) {
            console.error('File update error:', err);
            alert(`Error updating file: ${err.response?.data?.message || err.message}`);
        } finally {
            app.setState({ loading: false });
        }
    }

    render() {
        return (
            <div className={style.chonkyModal}>
                <div className={style.formGroup}>
                    <label>
                        File Name
                        <input
                            type="text"
                            name="fileName"
                            value={this.state.fileName}
                            disabled
                        />
                    </label>
                </div>

                <div className={style.formGroup}>
                    <label>
                        Description
                        <textarea
                            name="description"
                            value={this.state.description}
                            onChange={this.handleInputChange}
                        />
                    </label>
                </div>

                <div className={style.formGroup}>
                    <label>
                        Keywords
                        <input
                            type="text"
                            name="keywords"
                            value={this.state.keywords}
                            onChange={this.handleInputChange}
                            placeholder="Comma-separated keywords"
                        />
                    </label>
                </div>

                <div className={style.formGroup}>
                    <label>
                        Tags
                        <input
                            type="text"
                            name="tags"
                            value={this.state.tags}
                            onChange={this.handleInputChange}
                            placeholder="Comma-separated tags"
                        />
                    </label>
                </div>

                <button
                    onClick={this.handleEditFile}
                    className={`button`}
                >
                    <CustomIcon icon='save' /> Save Changes
                </button>
            </div>
        );
    }
}

export default EditFileModal;